import { useState } from 'react';
import type React from 'react';

import ClientProfile from 'containers/admin/clients/client/client-profile/client-profile';

import { transformClientToFormObject } from 'helpers/forms';

interface ClientLike {
  id: string | number;
  name: string;
  externalId?: string | number;
  state?: string;
  authorizedDomains?: string;
  identityProviderId?: string;
  expireDate?: string;
  consultants: Array<{
    id: string | number;
    user?: { id: string | number; name: string; [key: string]: unknown };
    consultantType: string;
  }>;
  [key: string]: unknown;
}

interface ProfileTabProps {
  client: ClientLike;
}

const ProfileTab = ({ client }: ProfileTabProps): React.JSX.Element => {
  const [isFormDisabled, setIsFormDisabled] = useState(true);

  return (
    <ClientProfile
      defaultValues={transformClientToFormObject(client)}
      showClientDeleteBtn
      isFormDisabled={isFormDisabled}
      setIsFormDisabled={setIsFormDisabled}
    />
  );
};

export default ProfileTab;
